import { ChangeDetectorRef, Component, OnDestroy, OnInit, input } from '@angular/core';
import { ContextService } from '../context.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mutara-progress-indicator',
  template: `
    @if (showProgress) {
      <section class='display-flex align-items-center'>
        <mat-label class='mutara-sm-strong'>{{label()}}</mat-label>
        <mat-progress-bar [value]="progress" [mode]="indeterminate ? 'indeterminate' : 'determinate'"
        class="mutara-progress-bar"></mat-progress-bar>
      </section>
    }
    `,
  standalone: false
})
export class ProgressIndicatorComponent implements OnDestroy {
  readonly label = input<string>('Progress');
  progress: number = 0;
  indeterminate: boolean = false;
  showProgress: boolean = false;
  subscriptions: Subscription [] = [];

  constructor(private contextSettings: ContextService, private cdr : ChangeDetectorRef) {

    this.subscriptions.push(this.contextSettings.subscribeTo("showProgressValue", (visible: boolean) => {
      this.showProgress = visible;
      this.cdr.markForCheck();
    }));
    this.subscriptions.push(this.contextSettings.subscribeTo("percentComplete", (complete: number) => {
      this.progress = complete;
    }));
    this.subscriptions.push(this.contextSettings.subscribeTo("indeterminateProgress", (indeterminate: boolean) => {
      this.indeterminate = indeterminate;
      this.cdr.markForCheck();
    }));
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach( sub => sub.unsubscribe() );
    this.subscriptions = [];
  }
}